import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { StyledNav } from "@insite/mobius/Breadcrumbs";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridWrapper } from "@insite/mobius/GridContainer";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { clearfixStyles } from "@store/theme/mixins";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface SubAssemblyItemsStyles {
    wrapper?: InjectableCss;
    leftWrapper?: InjectableCss;
    rightWrapper?: InjectableCss;
    container?: GridContainerProps;
    left?: GridItemProps;
    right?: GridItemProps;
}

export const specificationsStyles: SubAssemblyItemsStyles = {
    container: {
        isFullWidth: true,
        css: css`
            overflow: hidden;
        `,
    },
    left: {
        width: [12, 12, 8, 9, 9],
        css: css`
            padding: 0;
            ${GridWrapper} {
                ${clearfixStyles()}
                max-width: none;
            }
        `,
    },
    right: {
        width: [12, 12, 4, 3, 3],
        css: css`
            padding: 0;
            ${GridWrapper} {
                ${clearfixStyles()}
                max-width: none;
            }
        `,
    },
    leftWrapper: {
        css: css`
            width: 100%;
            padding-bottom: 30px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-left: 20px;
                        padding-right: 20px;
                    `,
                    css`
                        padding-left: 30px;
                        padding-right: 30px;
                    `,
                    css`
                        padding-left: 45px;
                        padding-right: 20px;
                    `,
                    css`
                        padding-left: 45px;
                        padding-right: 20px;
                    `,
                    css`
                        padding-left: 45px;
                        padding-right: 20px;
                    `,
                ])}
            ${StyledNav} {
                padding-top: 35px;
                flex-wrap: wrap;
            }
            > div > div {
                border-bottom: 0;
                padding-bottom: 0;
                margin-bottom: 0;
            }
            h1 {
                margin-bottom: 15px;
            }
        `,
    },
    rightWrapper: {
        css: css`
            position: relative;
            height: 100%;
            width: 100%;
            padding-top: 30px;
            top: -30px;
            > div,
            > div > div {
                height: 100%;
                position: relative;
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0 20px;
                    `,
                    css`
                        padding: 0 20px;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
};

const styles = specificationsStyles;

const ExplodedViewLayout: React.FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <GridContainer {...styles.container}>
                <GridItem {...styles.left}>
                    <StyledWrapper {...styles.leftWrapper}>
                        <Zone contentId={id} zoneName="Left" />
                    </StyledWrapper>
                </GridItem>
                <GridItem {...styles.right}>
                    <StyledWrapper {...styles.rightWrapper}>
                        <Zone contentId={id} zoneName="Right" />
                    </StyledWrapper>
                </GridItem>
            </GridContainer>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ExplodedViewLayout,
    definition: {
        displayName: "Exploded View Layout",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
